// Hero images - 4K quality from Unsplash/Pexels
export const heroImages = [
  "https://images.unsplash.com/photo-1612441804231-77a36b284856?w=2400&q=90",
  "https://images.unsplash.com/photo-1694059243966-ba36b71d661c?w=2400&q=90",
  "https://images.pexels.com/photos/1534855/pexels-photo-1534855.jpeg?auto=compress&cs=tinysrgb&w=2400",
  "https://images.pexels.com/photos/36160064/pexels-photo-36160064.jpeg?auto=compress&cs=tinysrgb&w=2400"
];

export const heroData = {
  name: "Ankit Mohanty",
  title: "Travel & Adventure Content Creation",
  tagline: "Capturing the world's most extraordinary places through cinematic storytelling"
};

export const socialProofData = [
  { label: "Followers", value: "520K+" },
  { label: "Views", value: "85M+" },
  { label: "Engagement Rate", value: "6.8%" },
  { label: "Countries Explored", value: "42+" }
];

// Social links
export const socialLinks = {
  instagram: "https://instagram.com/the.life.of.ankit",
  youtube: "https://www.youtube.com/channel/UCX-ikhY9qGYxOF5w5c76HJA",
  flickr: "https://www.flickr.com/people/203211046@N07/",
  email: "mohantyankit15@gmail.com"
};

export const workCategories = [
  {
    id: 1,
    title: "DRONE CINEMATICS",
    subtitle: "Aerial & 4K",
    image: "https://customer-assets.emergentagent.com/job_10b7905e-b05d-40f4-bcd7-066a3acbab43/artifacts/7nopxkdv_image.png"
  },
  {
    id: 2,
    title: "DESTINATIONS",
    subtitle: "Travel & Explore",
    image: "https://customer-assets.emergentagent.com/job_10b7905e-b05d-40f4-bcd7-066a3acbab43/artifacts/6vdiq7x5_IMG_3152.jpg"
  },
  {
    id: 3,
    title: "REELS & CONTENT",
    subtitle: "Short-form Stories",
    image: "https://customer-assets.emergentagent.com/job_10b7905e-b05d-40f4-bcd7-066a3acbab43/artifacts/u9mcdfue_IMG_1566.jpg"
  }
];

export const servicesData = [
  { id: 1, title: "Cinematic Reels", icon: "Film" },
  { id: 2, title: "Drone Videography", icon: "Plane" },
  { id: 3, title: "Travel Campaign Content", icon: "Camera" },
  { id: 4, title: "Hotel & Experience Features", icon: "MapPin" }
];

export const photoJournalData = [
  { id: 1, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/rh4het6o_IMG_5992.JPG.jpeg" },
  { id: 2, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/i76a92yt_IMG_5990.JPG.jpeg" },
  { id: 3, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/68kqy4d2_IMG_5984.JPG.jpeg" },
  { id: 4, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/l4xlxybi_IMG_5982.JPG.jpeg" },
  { id: 5, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/44s42rin_IMG_5972.JPG.jpeg" },
  { id: 6, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/mongrcps_IMG_5988.JPG.jpeg" },
  { id: 7, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/mz1pdvtt_IMG_5986.JPG.jpeg" },
  { id: 8, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/4pfiqkct_IMG_5978.JPG.jpeg" },
  { id: 9, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/uazucamd_IMG_5976.JPG.jpeg" },
  { id: 10, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/0184aqgg_IMG_5974.JPG.jpeg" },
  { id: 11, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/hsqprkp8_IMG_5970.JPG.jpeg" },
  { id: 12, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/h8785r9a_IMG_5968.JPG.jpeg" },
  { id: 13, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/we4583c9_IMG_5966.JPG.jpeg" },
  { id: 14, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/ecnz3n2u_IMG_5964.JPG.jpeg" },
  { id: 15, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/8gpn6c2h_IMG_5962.JPG.jpeg" },
  { id: 16, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/ns1vqz8v_IMG_5960.JPG.jpeg" },
  { id: 17, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/dmo1exc8_IMG_5958.JPG.jpeg" },
  { id: 18, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/9czszpim_IMG_5955.JPG.jpeg" },
  { id: 19, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/w3ye3337_IMG_5954.JPG.jpeg" },
  { id: 20, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/z0z7os46_54672511839_e66319af9d_b.jpg" },
  { id: 21, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/zthobemp_54672471964_5e79e4e0b0_b.jpg" },
  { id: 22, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/4sal8ez9_54671415867_5cdf35a544_b.jpg" },
  { id: 23, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/abf3dfio_54672264031_c51159d04e_b.jpg" },
  { id: 24, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/6r4qzrto_54672597485_f8be19c1fd_b.jpg" },
  { id: 25, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/sbu84xsh_54671456817_f9bb28f585_b.jpg" },
  { id: 26, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/32l3arg0_54672615515_db1b4f48bd_b.jpg" },
  { id: 27, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/t67qjjb3_54672521929_13235ef9ba_b.jpg" },
  { id: 28, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/ymn7ezf6_IMG_5997.JPG.jpeg" },
  { id: 29, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/s5nlp0q3_IMG_5996.JPG.jpeg" },
  { id: 30, image: "https://customer-assets.emergentagent.com/job_8c7ce033-0e5f-48f7-a0ce-fb43892041e3/artifacts/bys7lkoa_IMG_5998.JPG.jpeg" },
];

export const aboutData = {
  text: "I’ve always been drawn to places, not just for how they look, but for how they feel. Through my work, I capture that feeling and translate it into visual stories that connect with people, while helping destinations and brands showcase their identity in a meaningful way.",
  longText: "For me, travel is more than movement, it’s about perspective, emotion, and the moments that stay with you long after you leave. Through cinematic visuals, both on the ground and in the air. I create content that feels immersive, drives engagement, and leaves a lasting impression.",
  image: "https://customer-assets.emergentagent.com/job_10b7905e-b05d-40f4-bcd7-066a3acbab43/artifacts/1q0muchr_IMG_5953.PNG"
};

export const contactData = {
  email: "mohantyankit15@gmail.com",
  instagram: "@the.life.of.ankit"
};
